'use strict';
const angular = require('angular');

export default angular.module('conduu.ap.components.bindDynamicPage', [])
  .directive('bindDynamicPage', function($compile) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        scope.$watch(
          function(scope) {
            return scope.$eval(attrs.bindDynamicPage);
          },
          function(value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/bind-dynamic-page/bind-dynamic-page.directive.js